import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData, postData, updateData, masterdataindex } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import Select from 'react-select';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import AddIcon from '@mui/icons-material/Add';

function BalanceSheetIndex() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);  // Modal state
    const [name, setName] = useState("");

    const history = useHistory();
    const { isAuthenticated, companyId, permissions, userId, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');
    const [loading, setLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [isFocused, setIsFocused] = useState(false);


    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();

            return;
        }
        // Token is not expired, fetch data
        fetchtableData();
        setLoading(true);
    }, [isAuthenticated, companyId, userId, token, logout]);

    const fetchtableData = async () => {
        setLoading(true);
        fetchData('BalanceSheetApi', `/${companyId}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setData(response.response_data);
                }
                console.log(response);
            })

            .catch((error) => {
                console.error('Error fetching BalanceSheet:', error);
                // Handle error, e.g., redirect to login if token is expired
                if (error.response && error.response.status === 401) {
                    logout();
                    // Redirect to login with the current location as a parameter
                    history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
                }
            })
            .finally(() => {
                setLoading(false); // Hide loading screen
            });
    };

    const handleDelete = async () => {
        deleteData('BalanceSheetApi', `${deleteItemId}`, token)
            .then((response) => {
                setDeleteItemId(null);
                setConfirmDialogOpen(false);
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };

    const handleActivate = (itemId) => {
        activateData('BalanceSheetApi', `${itemId}`)
            .then(() => {
                // Fetch table data or update state
            })
            .catch((error) => {
                console.error('Error activating record:', error);
            });
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };


    const addRecord = async (e) => {
        e.preventDefault();

        if (!name) {
            setErrorMessage('Name is required !');
            setIsLoading(false);
            return;
        }

        const CreateData = {
            Name: name,
            CreatedBy: userId,
            CompanyId: companyId,
            CreatedDate: new Date(),
        };

        postData('BalanceSheetApi', CreateData, token)
            .then((response) => {
                console.log('BalanceSheetHead Created success:', response);
                setSuccessMessage("BalanceSheetHead Created successfully!");
                setErrorMessage("");
                setName('');
                setIsModalOpen(false);
                window.location.reload();
                setTimeout(() => {
                    setSuccessMessage("");
                }, 3000);
            })
            .catch((error) => {
                console.error('Item Create error:', error);
                setIsLoading(false);
            });
    };


    //EDIT
    const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);

    const openDetailModal = async (id) => {
        try {
            const response = await fetchData('BalanceSheetApi', `/CategoryDetails/${id}`, token);
            if (response.responseCode === '1111') {
                setUpdateData(response.response_data);
                setIsDetailModalOpen(true);
            }
        } catch (error) {
            console.error('Error fetching Item Details:', error);
        }
    };

    const toggleModalBranch = () => {
        setIsDetailModalOpen(false); // Step 2
    };

    const handleUpdateInputChange = (event) => {
        const { name, value } = event.target;
        setUpdateData((prevDataItem) => ({
            ...prevDataItem,
            [name]: value,
        }));
    };

    const [updatedData, setUpdateData] = useState({});



    const updateRecord = async (event) => {
        event.preventDefault();
        if (!updatedData.Name) {
            setErrorMessage('Name is required !');
            setIsLoading(false);
            return;
        }

        try {
            const updatedPayload = {
                ...updatedData,
                Name: name,
                CompanyId: companyId
            };

            await updateData('BalanceSheetApi', `${updatedData.Id}`, updatedPayload, token);
            setUpdateData({
                CompanyId: companyId,
                Name: '',
            });
            setIsDetailModalOpen(false);
            fetchtableData();
            setSuccessMessage("BalanceSheetHead updated successfully!");
            setTimeout(() => {
                setSuccessMessage("");
            }, 3000);
        } catch (error) {
            console.error('Error updating record:', error);
            setErrorMessage("Failed to update BalanceSheetHead.");
        }
    };


    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    //handle search
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    return (
        <div className="w-full max-w-sm container mt-2 mx-auto">
            <div className='w-full mb-2 flex' style={{ marginTop: '-20px' }}>
                <h6 className='productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}>BALANCE SHEET</h6>
                <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'left', marginTop: '10px' }}>
                    <input
                        className="shadow text-gray-700 leading-tight"
                        type="text"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={handleSearch}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                        style={{
                            width: isFocused ? '270px' : '200px',
                            height: '25px',
                            border: '1px solid #ccc',
                            borderRadius: '15px',
                            padding: '0 20px',
                            transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                            outline: 'none',
                            borderColor: isFocused ? 'darkcyan' : '#ccc',
                            boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                        }}
                    />
                </div>

                <Tooltip title="Create Balance Sheet Head" arrow>
                    <Button
                        style={{ backgroundColor: '#3F4F44', color: 'white', height: '26px', marginRight: '8px', marginLeft: '5px', marginTop: '10px' }}
                        onClick={toggleModal}
                    >
                           <span style={{ fontSize: '13px' }}>Create </span>
                    </Button>
                </Tooltip>
            </div>


            {isModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center z-10">
                    <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-3xl max-h-[90vh] overflow-y-auto
                        animate-zoomIn"
                    >
                        <h6 style={{ textAlign: 'center', fontWeight: 'bolder', fontFamily: 'monospace' }}>BALANCE SHEET CREATE</h6>
                        {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                        <div className="w-full mb-4 flex">
                            <div className="w-1/4 mr-2" style={{ width: '80%' }}>
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="name">
                                    Name  <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    type="text"
                                    name="Name"
                                    placeholder="Enter Name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                />
                            </div>
                        </div>

                        <div className="flex w-full md:w-auto justify-center md:justify-center mt-2 md:mt-0">
                            <Button
                                style={{ backgroundColor: 'rgb(12, 151, 125)', color: 'white', height: '26px', marginRight: '8px' }}
                                onClick={addRecord}
                                className="linkcolor"
                            >
                                <span style={{ fontSize: '11px' }}>Add </span>
                            </Button>
                            <Button
                                style={{ backgroundColor: 'rgb(149, 72, 4)', color: 'white', height: '26px', marginRight: '8px' }}
                                onClick={toggleModal}
                                className="linkcolor"
                            >
                                <span style={{ fontSize: '11px' }}>Cancel</span>
                            </Button>
                        </div>
                    </div>
                </div>
            )
            }

            <div className='w-full mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto', width: '100%', marginTop: '-10px' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: 'white' }}>
                            <TableRow>
                                <TableCell className='table-header-cell'>Sl.No</TableCell>
                                <TableCell className='table-header-cell'>Name</TableCell>
                                <TableCell className='table-header-cell'></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody style={{ backgroundColor: 'white' }}>
                            {filteredData.map((item, index) => (
                                <TableRow
                                    key={item.id}
                                    className={item.isActive ? '' : 'inactiveRow'}
                                    sx={{
                                        '&:hover': {
                                            backgroundColor: '#E3FEF7', // Change color on hover
                                            cursor: 'pointer'
                                        },
                                    }}
                                >
                                    <TableCell
                                        className='table-header-cell.child' style={{ padding: '3px' }}
                                    >
                                        {index + 1}
                                    </TableCell>

                                    <TableCell
                                        className='table-header-cell.child' style={{ padding: '3px' }}
                                    >
                                        {item.name}
                                    </TableCell>
                                    <TableCell
                                        className='table-header-cell.child' style={{ padding: '3px', textAlign: 'right' }}
                                    >
                                        {hasEditMasterPermission && (
                                            <Tooltip title="Edit" arrow>
                                                <IconButton onClick={() => openDetailModal(item.id)}>
                                                    <EditIcon style={{ color: 'blueviolet', fontSize: '19px' }} />
                                                </IconButton>
                                            </Tooltip>
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>

                        <Dialog
                            open={confirmDialogOpen}
                            onClose={closeConfirmDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Are you sure you want to delete ?
                                </DialogContentText>
                            </DialogContent>

                            <DialogActions>
                                <button
                                    onClick={closeConfirmDialog}
                                    style={{
                                        backgroundColor: '#dc3545',
                                        color: '#ffffff',
                                        border: '1px solid #dc3545',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                        marginRight: '8px',
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleDelete}
                                    style={{
                                        backgroundColor: '#28a745',
                                        color: '#ffffff',
                                        border: '1px solid #28a745',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                    }}
                                >
                                    Confirm
                                </button>
                            </DialogActions>

                        </Dialog>
                    </Table>
                </TableContainer>

                {isDetailModalOpen && (
                    <div className="fixed inset-0 flex items-center justify-center z-10">
                        <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-3xl max-h-[90vh] overflow-y-auto
                        animate-zoomIn"
                        >
                            <h6 style={{ textAlign: 'center', fontWeight: 'bolder', fontFamily: 'monospace' }}>BALANCE SHEET EDIT</h6>
                            {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                            <div className="w-full mb-4 flex">
                                <div className="w-1/4 mr-2" style={{ width: '80%' }}>
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="name">
                                        Name <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        type="text"
                                        name="Name"
                                        placeholder="Enter name"
                                        value={updatedData.Name}
                                        onChange={handleUpdateInputChange}

                                    />
                                </div>
                            </div>

                            <div className="flex w-full md:w-auto justify-center md:justify-center mt-2 md:mt-0">
                                <Button
                                    style={{ backgroundColor: 'rgb(12, 151, 125)', color: 'white', height: '26px', marginRight: '8px' }}
                                    onClick={updateRecord}
                                    className="linkcolor"
                                >
                                    <span style={{ fontSize: '11px' }}>Update</span>
                                </Button>
                                <Button
                                    style={{ backgroundColor: 'rgb(149, 72, 4)', color: 'white', height: '26px', marginRight: '8px' }}
                                    onClick={toggleModalBranch}
                                    className="linkcolor"
                                >
                                    <span style={{ fontSize: '11px' }}>Cancel</span>
                                </Button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div >
    );
}

export default BalanceSheetIndex;
